import { render, staticRenderFns } from "./assign_module.vue?vue&type=template&id=72f3d45d"
import script from "./assign_module.vue?vue&type=script&lang=js"
export * from "./assign_module.vue?vue&type=script&lang=js"
import style0 from "./assign_module.vue?vue&type=style&index=0&id=72f3d45d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports